import { SigninPageCombinedProps } from './types';

const usePresenter = (props: SigninPageCombinedProps): SigninPageCombinedProps => {
  return props;
};

export default usePresenter;
